import React from "react";
export default function PlaceholderSVG() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 245 310",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.886 39.098c1.975 25.644-22.325 55.153-31.764 55.89-8.258.645-37.972-24.727-39.947-50.37C93.2 18.972 108.168 3.644 127.97 2.12 147.774.6 164.91 13.455 166.887 39.1",
    fill: "#E24270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.886 39.098c1.975 25.644-22.325 55.153-31.764 55.89-8.258.645-37.972-24.727-39.947-50.37C93.2 18.972 108.168 3.644 127.97 2.12 147.774.6 164.91 13.455 166.887 39.1z",
    stroke: "#BB0049",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38 99s-4.393 25.27 16.675 79.635c21.835 56.343.905 87.365.905 87.365",
    stroke: "#808285",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.786 96.263l-3.607 5.22c-.618.895.493 1.963 1.373 1.322l3.045-2.215 4.22 2.174c.804.414 1.576-.6.957-1.253l-5.04-5.32c-.268-.28-.73-.246-.95.073",
    fill: "#E24270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.786 96.263l-3.607 5.22c-.618.895.493 1.963 1.373 1.322l3.045-2.215 4.22 2.174c.804.414 1.576-.6.957-1.253l-5.04-5.32c-.268-.28-.73-.246-.95.073z",
    stroke: "#BB0049",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.18 86.916c-3.846 20.83-28.086 39.36-35.276 38.015-6.292-1.174-23.187-27.46-19.34-48.29 3.845-20.827 18.185-29.973 33.267-27.136 15.083 2.838 25.196 16.583 21.35 37.412",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.18 86.916c-3.846 20.83-28.086 39.36-35.276 38.015-6.292-1.174-23.187-27.46-19.34-48.29 3.845-20.827 18.185-29.973 33.267-27.136 15.083 2.838 25.196 16.583 21.35 37.412z",
    stroke: "#F15A29",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.264 127s11.83 8.563-1.903 44.83c-43.046 113.684 27.63 102.178-5.446 114.17",
    stroke: "#808285",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.094 124.174l-2.923 3.936c-.5.674.195 1.637.86 1.19l2.3-1.54 2.786 2.126c.53.405 1.148-.353.765-.938l-3.117-4.753c-.165-.25-.49-.262-.67-.02",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.094 124.174l-2.923 3.936c-.5.674.195 1.637.86 1.19l2.3-1.54 2.786 2.126c.53.405 1.148-.353.765-.938l-3.117-4.753c-.165-.25-.49-.262-.67-.02z",
    stroke: "#F15A29",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24270",
    d: "M7.366 125L0 121.366 3.634 114 11 117.634"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BB673",
    d: "M205.793 189L201 181.793l7.206-4.793 4.794 7.206M38.793 227L34 219.794 41.206 215 46 222.207"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C739AE",
    d: "M241.365 119L234 115.365l3.635-7.365 7.365 3.635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.82 132.916c3.846 20.828 28.086 39.36 35.277 38.015 6.29-1.174 23.187-27.46 19.34-48.29-3.845-20.827-18.186-29.973-33.268-27.136-15.083 2.838-25.196 16.583-21.35 37.412",
    fill: "#27AAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.82 132.916c3.846 20.828 28.086 39.36 35.277 38.015 6.29-1.174 23.187-27.46 19.34-48.29-3.845-20.827-18.186-29.973-33.268-27.136-15.083 2.838-25.196 16.583-21.35 37.412z",
    stroke: "#1B75BC",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.578 173s-12.91 7.878.553 38.35c22.452 50.803-11.7 39.804 2.025 97.65",
    stroke: "#808285",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.906 170.174l2.923 3.936c.5.674-.195 1.637-.86 1.19l-2.3-1.54-2.786 2.126c-.53.404-1.148-.353-.765-.938l3.117-4.753c.165-.25.49-.262.67-.02",
    fill: "#27AAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.906 170.174l2.923 3.936c.5.674-.195 1.637-.86 1.19l-2.3-1.54-2.786 2.126c-.53.404-1.148-.353-.765-.938l3.117-4.753c.165-.25.49-.262.67-.02z",
    stroke: "#1B75BC",
    strokeWidth: "2"
  })));
}